import { getProject } from "authoring/routes/project/controller/get-project"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"

export function useProject({ id }) {
    const project = getProject.useResults({ projectId: id }, withInitialValue(IS_LOADING))
    return { loading: project === IS_LOADING, project: project === IS_LOADING ? undefined : project }
}

/** Loads project once per mount; ignores cache invalidations (schedule editor hot path). */
export function useProjectOnce({ id }) {
    const project = getProject.useResultsOnce({ projectId: id }, withInitialValue(IS_LOADING))
    return { loading: project === IS_LOADING, project: project === IS_LOADING ? undefined : project }
}
